"use client";

import WeatherCard from "./WeatherCard";
import AllergyCard from "./AllergyCard";
import HoroscopeCard from "./HoroscopeCard";
import NewsCard from "./NewsCard";
import { useEffect, useState } from "react";
import { getNews } from "../../services/news";
import QuestionCard from "./QuestionCard";
import { getQuestions } from "../../services/poll";
import SidebarNewsCardSkeleton from "../skeletons/SidebarNewsCardSkeleton";
import QuestionCardSkeleton from "../skeletons/QuestionCardSkeleton";
import DesktopArticleCard from "../gallyonomics_components/DesktopCard";
import { listMarketPulseArticle } from "../../services/article";

function HomeRightSidebar({ onClick }) {
  const [newsData, setNewsData] = useState([]);
  const [questions, setQuestions] = useState(null);
  const [newsLoading, setNewsLoading] = useState(true);
  const [questionsLoading, setQuestionsLoading] = useState(true);
  const [marketPulse, setMarketPulse] = useState(null);

  useEffect(() => {
    async function fetchAllMarketPulses() {
      try {
        const response = await listMarketPulseArticle({ offset: 0, limit: 3 });
        setMarketPulse(response);
      } catch (error) {
        console.error("Error while trying to fetch market pulses: ", error);
      }
    }

    fetchAllMarketPulses();
  }, []);

  useEffect(() => {
    async function fetchQuestions() {
      try {
        setQuestionsLoading(true);
        const geohash = localStorage.getItem("geohash") || "9v6m";
        const questionsResponse = await getQuestions(geohash);
        setQuestions(questionsResponse.data);
      } catch (error) {
        console.error("Error while fetching questions : ", error);
      } finally {
        setQuestionsLoading(false);
      }
    }
    if (!questions) {
      fetchQuestions();
    }
  }, []);

  useEffect(() => {
    async function fetchNews() {
      try {
        setNewsLoading(true);
        const news = await getNews();
        setNewsData(news[0].news.slice(0, 4));
      } catch (error) {
        console.error("Error while fetching news", error);
      } finally {
        setNewsLoading(false);
      }
    }
    fetchNews();
  }, []);

  const renderQuestionSkeletons = () => {
    return Array.from({ length: 2 }, (_, index) => (
      <QuestionCardSkeleton key={`question-skeleton-${index}`} />
    ));
  };

  return (
    <div className="p-5 flex flex-col">
      <div className="flex flex-col gap-[10px]">
        <div className="mb-2">
          <div className="text-gray-500 text-sm mb-1">
            {new Date().toLocaleDateString("en-GB", {
              weekday: "long",
              day: "numeric",
              month: "short",
            })}
          </div>

          <h2 className="text-xl font-bold font-fraunces">
            <span>Today's </span>
            <span className="">Forecast</span>
          </h2>
        </div>

        <WeatherCard />
        <AllergyCard />
        <HoroscopeCard />

        <div className="w-full h-px bg-gray-200 my-4" />

        <div className="flex flex-col gap-4">
          <div className="ml-auto mr-auto flex-none w-fit snap-center">
            <div className="rounded-lg overflow-hidden h-64">
              <img
                src="/images/image0.webp"
                alt="VR headset promotional image showing virtual reality experience"
                className="w-full h-full object-contain"
                onClick={onClick}
              />
            </div>
          </div>
        </div>

        <div className="w-full h-px bg-gray-200 my-4" />

        {(questionsLoading || (questions && questions.length > 0)) && (
          <div className="mb-2">
            <h2 className="text-xl font-bold font-fraunces">
              <span>Community </span>
              <span className="">Questions</span>
            </h2>
          </div>
        )}

        {questionsLoading
          ? renderQuestionSkeletons()
          : questions &&
            questions.length > 0 &&
            questions.map((question) => (
              <QuestionCard key={question.question_id} question={question} />
            ))}
        <div className="w-full h-px bg-gray-200 my-4" />

        <div className="w-[99%] mx-auto bg-white pt-1 pl-4 pr-4 pb-4 overflow-hidden font-afacad">
          {!marketPulse ? (
            <SidebarNewsCardSkeleton />
          ) : (
            <div className="space-y-1">
              {marketPulse.map((mp) => (
                <DesktopArticleCard key={mp.id || mp.article_title} marketPulse={mp} />
              ))}
            </div>
          )}
        </div>

        <div className="w-full h-px bg-gray-200 my-4" />

        <div className="mb-2">
          <h2 className="text-xl font-bold font-fraunces">
            <span>Local </span>
            <span>Buzz</span>
          </h2>
        </div>

        <div className="w-[99%] mx-auto bg-white pt-1 pl-4 pr-4 pb-4 overflow-hidden font-afacad">
          {newsLoading ? (
            <SidebarNewsCardSkeleton />
          ) : (
            <div className="space-y-1">
              {newsData.map((item, index) => (
                <NewsCard key={index} item={item} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HomeRightSidebar;
